import { flatten, orderBy as sortBy } from 'lodash'
import IAPIAccess from '../../model/IAPIAccess'
import IAPIKey from '../../model/IAPIKey'
import { sortKey } from '../../helpers/sortKey'

export interface IApiAccessGroup {
  account: IAPIAccess
  keys: IAPIKey[]
}

export const sortApiAccessRows = (
  groups: IApiAccessGroup[],
  orderBy: string[],
  order: string[]
): (IAPIAccess | IAPIKey)[] => {
  const direction = order as ('asc' | 'desc')[]
  const accountIteratees = orderBy.map(field => (group: IApiAccessGroup) =>
    sortKey(group.account[field])
  )
  const keyIteratees = orderBy.map(field => (key: IAPIKey) =>
    sortKey(key[field])
  )

  return flatten(
    sortBy(groups, accountIteratees, direction).map(group => [
      group.account,
      ...sortBy(group.keys, keyIteratees, direction)
    ])
  )
}
